var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c("v-client-table", {
        attrs: {
          name: "receiptStatus",
          data: _vm.tableData,
          columns: _vm.tableColumns,
          options: _vm.tableOptions,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "beforeTable",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.dateFrom,
                            expression: "dateFrom",
                          },
                        ],
                        attrs: { type: "date", placeholder: "請選擇起日" },
                        domProps: { value: _vm.dateFrom },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.dateFrom = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" - "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.dateTo,
                            expression: "dateTo",
                          },
                        ],
                        attrs: { type: "date", placeholder: "請選擇迄日" },
                        domProps: { value: _vm.dateTo },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.dateTo = $event.target.value
                          },
                        },
                      }),
                      _c(
                        "Button",
                        {
                          attrs: { small: "", transparent: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.filterByDateRange.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v(" 查詢 ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3443400747
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }